import { h, Component } from 'preact';
import { route } from 'preact-router';
import TopAppBar from 'preact-material-components/TopAppBar';
import Drawer from 'preact-material-components/Drawer';
import List from 'preact-material-components/List';
import Dialog from 'preact-material-components/Dialog';
import Switch from 'preact-material-components/Switch';
import Fab from 'preact-material-components/Fab';
import 'preact-material-components/Switch/style.css';
import 'preact-material-components/Dialog/style.css';
import 'preact-material-components/Drawer/style.css';
import 'preact-material-components/List/style.css';
import 'preact-material-components/TopAppBar/style.css';
import 'preact-material-components/Fab/style.css';
import { connect } from 'redux-zero/preact';
import actions from '../../actions';
import { Home } from '../../routes/home';

import style from './style';

class Header extends Component {
	closeDrawer() {
		this.drawer.MDComponent.open = false;
		this.state = {
			darkThemeEnabled: false
		};
	}

	openDrawer = () => (this.drawer.MDComponent.open = true);
	drawerRef = drawer => (this.drawer = drawer);

	linkTo = path => () => {
		this.closeDrawer();
		setTimeout(() => {
			route('/');
			route(path);
		}, 500);
	};

	render(props) {
		return (
			<div>
				<TopAppBar className="topappbar">
					<TopAppBar.Row>
						<TopAppBar.Section align-start>
							<TopAppBar.Icon menu onClick={this.openDrawer} style={{ cursor: 'pointer' }}>
								menu
							</TopAppBar.Icon>
							<TopAppBar.Title>Posiłki profilaktyczne</TopAppBar.Title>
						</TopAppBar.Section>
						<TopAppBar.Section align-end shrink-to-fit>
							<TopAppBar.Icon onClick={this.linkTo('/home')} style={{ cursor: 'pointer', marginLeft: 15 }}>home</TopAppBar.Icon>
							{this.props.isAdmin && <TopAppBar.Icon onClick={this.linkTo('/ustawienia')} style={{ cursor: 'pointer', marginLeft: 15  }}>settings</TopAppBar.Icon>}
							{this.props.isAdmin && <TopAppBar.Icon onClick={this.linkTo('/uzytkownicy')} style={{ cursor: 'pointer', marginLeft: 15  }}>people</TopAppBar.Icon>}
							<TopAppBar.Icon onClick={this.linkTo('/raport')} style={{ cursor: 'pointer', marginLeft: 15  }}>file_download</TopAppBar.Icon>
							<TopAppBar.Icon onClick={this.linkTo('/logout')} style={{ cursor: 'pointer', marginLeft: 15  }}>logout</TopAppBar.Icon>
						</TopAppBar.Section>
					</TopAppBar.Row>
				</TopAppBar>
				<Drawer modal ref={this.drawerRef}>
					{this.props.user && <Drawer.DrawerHeader style={{
						background: 'url("/assets/drawer.jpg") top left no-repeat',
						backgroundSize: 'cover',
						color: '#ffffff',
						padding: 15
					}}>
						<div>
							<img src="/assets/logo-white.png" style={{
								width: 256 / 2,
								height: 77 / 2,
								marginBottom: 15
							}} />
							<h4>Posiłki profilaktyczne</h4>
						</div>
						<div>
							<div>{this.props.user.imie} {this.props.user.nazwisko}</div>
							{this.props.isAdmin && <small>Administrator BHP</small>}
						</div>
					</Drawer.DrawerHeader>}
					<Drawer.DrawerContent>
						<div className={style.menuFocusTrap} tabIndex={0}>
							<Drawer.DrawerItem selected={props.selectedRoute === '/home'} onClick={this.linkTo('/home')}>
								<List.ItemGraphic>home</List.ItemGraphic>
								Home
							</Drawer.DrawerItem>
							{this.props.isAdmin && (<Drawer.DrawerItem selected={props.selectedRoute === '/ustawienia'} onClick={this.linkTo('/ustawienia')}>
								<List.ItemGraphic>settings</List.ItemGraphic>
								Ustawienia
							</Drawer.DrawerItem>)}
							{this.props.isAdmin && (<Drawer.DrawerItem selected={props.selectedRoute === '/uzytkownicy'} onClick={this.linkTo('/uzytkownicy')}>
								<List.ItemGraphic>people</List.ItemGraphic>
								Użytkownicy
							</Drawer.DrawerItem>)}
							<Drawer.DrawerItem selected={props.selectedRoute === '/raport'} onClick={this.linkTo('/raport')}>
								<List.ItemGraphic>file_download</List.ItemGraphic>
								Raport
							</Drawer.DrawerItem>
							<Drawer.DrawerItem selected={props.selectedRoute === '/logout'} onClick={this.linkTo('/logout')}>
								<List.ItemGraphic>logout</List.ItemGraphic>
								Wyloguj
							</Drawer.DrawerItem>
						</div>
					</Drawer.DrawerContent>
				</Drawer>
			</div>
		);
	}
}

export default connect(({ logout, isAdmin, user }) => ({ logout, isAdmin, user }), actions)(Header);



// WEBPACK FOOTER //
// ./components/header/index.js